/* erx-w4-b2b.js - the /pages/b2b request form (sections/erx-w4-b2b.liquid). Adapted from
   assets/ergonix-b2b-trial-page.js (the old page) with the SAME measurement contract, so Google Ads / GA4 / Meta
   keep counting: dataLayer + Shopify.analytics events b2b_form_start, b2b_form_step, b2b_form_submit and, on the
   thank-you render after a send from this tab, generate_lead (same sessionStorage key 'ergonix_b2b_lead', personal
   data only with marketing consent). The form itself is Shopify's contact form: no third-party endpoint.
   Differences from the old file: no configurator and no <dialog>; on a computer (>= 1025 px) all three field
   groups are visible at once (mockup verslui/v1), on a phone it is 3 steps with „Toliau · N iš 3". */
(function () {
  'use strict';
  // The page promises the free trial to companies „nuo 20 žmonių" (20 and more).
  function eligible(employeeCount, products) {
    const count = Number(employeeCount);
    return Number.isInteger(count) && count >= 20 && count <= 1000000 && products.length > 0;
  }
  function track(name, data) {
    const payload = Object.assign({ form_id: 'b2b_trial' }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload);
    } catch (e) { /* a pixel error must never break the form */ }
  }
  function employeesBand(value) {
    const n = Number(value);
    if (!Number.isInteger(n) || n < 1) return 'unknown';
    return n <= 20 ? '1-20' : n < 50 ? '21-49' : n < 100 ? '50-99' : n < 250 ? '100-249' : '250+';
  }
  const LEAD_KEY = 'ergonix_b2b_lead';
  function marketingOk() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed && Shopify.customerPrivacy.marketingAllowed()); } catch (e) { return false; }
  }
  function whenConsentKnown(cb) {
    let done = false;
    const finish = () => { if (!done) { done = true; cb(marketingOk()); } };
    if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.marketingAllowed) { finish(); return; }
    setTimeout(finish, 3000);
    try {
      if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
    } catch (e) { /* the timeout still fires */ }
  }
  function userData(form) {
    const email = ((form.querySelector('#bt-email') || {}).value || '').trim().toLowerCase();
    let phone = ((form.querySelector('#bt-phone') || {}).value || '').replace(/[^\d+]/g, '');
    if (/^8\d{8}$/.test(phone)) phone = `+370${phone.slice(1)}`;
    else if (/^370\d{8}$/.test(phone)) phone = `+${phone}`;
    else if (/^00\d+$/.test(phone)) phone = `+${phone.slice(2)}`;
    const data = {};
    if (email) data.email = email;
    if (/^\+\d{8,15}$/.test(phone)) data.phone_number = phone;
    return Object.keys(data).length ? data : null;
  }

  function init(root) {
    const card = root.querySelector('.erx-w4-card');
    const form = root.querySelector('.bt-form');
    if (!form || form.dataset.enhanced) return;
    form.dataset.enhanced = 'true';

    // Sent: the conversion, once, only after a send made from this tab.
    if (form.querySelector('.bt-success')) {
      let lead = null;
      try { lead = JSON.parse(sessionStorage.getItem(LEAD_KEY) || 'null'); sessionStorage.removeItem(LEAD_KEY); } catch (e) { lead = null; }
      if (lead) {
        whenConsentKnown(ok => {
          if (!ok) delete lead.user_data;
          track('generate_lead', Object.assign(lead, { value: lead.set_value || 0 }));
        });
      }
    }
    // Back from a POST (thank-you or error): bring the card into view.
    if (card && (form.querySelector('.bt-success, .bt-errors[role="alert"]:not([hidden]):not([data-form-error])') || /contact_posted/.test(location.href))) {
      setTimeout(() => card.scrollIntoView({ block: 'start' }), 60);
      const ok = form.querySelector('.bt-success');
      if (ok) ok.focus({ preventScroll: true });
    }
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    if (!steps.length) return;

    const strings = JSON.parse(root.querySelector('[data-b2b-strings]').textContent);
    const next = form.querySelector('[data-next]');
    const back = form.querySelector('[data-back]');
    const submit = form.querySelector('[data-submit]');
    const error = form.querySelector('[data-form-error]');
    const productError = form.querySelector('[data-product-error]');
    const products = () => Array.from(form.querySelectorAll('[data-product]:checked')).map(el => el.dataset.product);
    const wide = window.matchMedia('(min-width: 1025px)');
    let current = 0;
    let started = false, submitted = false;
    const STEP_NAMES = ['company', 'contact_person', 'contact_details'];
    const stepped = () => !wide.matches;

    form.addEventListener('input', () => {
      if (started) return;
      started = true;
      track('b2b_form_start', { mode: 'page' });
    });
    function paint(focus) {
      const st = stepped();
      form.classList.toggle('is-stepped', st);
      if (!st) current = steps.length - 1;
      steps.forEach((step, index) => { step.hidden = st ? index !== current : false; });
      next.hidden = !st || current === steps.length - 1;
      submit.hidden = st && current !== steps.length - 1;
      back.hidden = !st || current === 0;
      next.textContent = `${strings.next} · ${current + 1} ${strings.of} ${steps.length}`;
      const qualifies = eligible(form.querySelector('#bt-employees').value, products());
      form.querySelector('[data-eligibility]').value = qualifies ? 'Taip – 20 ir daugiau darbuotojų, pasirinktos prekės (patvirtina pardavimų komanda)' : 'Ne – bendra verslo užklausa';
      const outcome = form.querySelector('[data-outcome]');
      const touched = form.querySelector('#bt-employees').value && products().length;
      outcome.textContent = qualifies ? strings.eligible : strings.general;
      outcome.hidden = !(st ? current === steps.length - 1 : touched);
      if (focus) steps[current].querySelector('input, textarea').focus();
    }
    function invalid(step) {
      const fields = Array.from(step.querySelectorAll('input:not([type=hidden]):not([type=checkbox]), textarea'));
      let first = null;
      fields.forEach(field => {
        const blank = field.required && !field.value.trim();
        const valid = !blank && field.validity.valid;
        field.setAttribute('aria-invalid', String(!valid));
        if (!valid && !first) first = field;
      });
      if (step === steps[0]) {
        const missingProducts = !products().length;
        productError.hidden = !missingProducts;
        step.querySelectorAll('[data-product]').forEach(field => {
          field.setAttribute('aria-invalid', String(missingProducts));
          if (missingProducts) field.setAttribute('aria-describedby', 'bt-product-error');
          else field.removeAttribute('aria-describedby');
        });
        if (missingProducts && !first) first = step.querySelector('[data-product]');
      }
      return first;
    }
    function advance() {
      const bad = invalid(steps[current]);
      error.hidden = !bad;
      if (bad) { bad.focus(); return; }
      current = Math.min(current + 1, steps.length - 1);
      track('b2b_form_step', { step: current + 1, step_name: STEP_NAMES[current] || String(current + 1) });
      paint(true);
      if (card) card.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    next.addEventListener('click', advance);
    back.addEventListener('click', () => { current = Math.max(0, current - 1); error.hidden = true; paint(true); });
    form.addEventListener('change', event => { if (event.target.matches('[data-product]')) { productError.hidden = true; paint(false); } });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT' && stepped() && current < steps.length - 1) {
        event.preventDefault(); advance();
      }
    });
    function validateSubmission(event) {
      if (stepped() && current < steps.length - 1) { event.preventDefault(); advance(); return; }
      for (let i = 0; i < steps.length; i++) {
        const bad = invalid(steps[i]);
        if (bad) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (stepped()) current = i;
          error.hidden = false; paint(false); bad.focus(); return;
        }
      }
      error.hidden = true;
      paint(false);
      if (!submitted) {
        submitted = true;
        const employees = form.querySelector('#bt-employees').value;
        const lead = {
          lead_type: eligible(employees, products()) ? 'trial' : 'general',
          employees_band: employeesBand(employees),
          event_id: `b2b-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
          items_in_set: products().length,
          set_value: 0,
          currency: 'EUR'
        };
        track('b2b_form_submit', lead);
        const stored = Object.assign({}, lead);
        const who = marketingOk() && userData(form);
        if (who) stored.user_data = who;
        try { sessionStorage.setItem(LEAD_KEY, JSON.stringify(stored)); } catch (e) { /* private mode: the email still goes */ }
      }
      // Reveal every group before Shopify's own challenge / validation handles the real submission.
      steps.forEach(step => { step.hidden = false; });
    }
    submit.addEventListener('click', validateSubmission, true);
    form.addEventListener('submit', validateSubmission, true);
    productError.id = 'bt-product-error';
    if (wide.addEventListener) wide.addEventListener('change', () => { current = 0; paint(false); });
    paint(false);
  }
  document.querySelectorAll('[data-b2b-trial]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-b2b-trial]').forEach(init);
  });
})();
